let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c72S8")).then(() => parcelRequire('74Yv6'));